var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil2 = function SvgPencil2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F3D8B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m3.833 28.667 7.4-2.846c.473-.182.71-.273.93-.392q.296-.158.561-.364c.198-.154.378-.333.736-.692L28.5 9.333A3.771 3.771 0 1 0 23.167 4L8.127 19.04c-.359.358-.538.538-.692.736a4 4 0 0 0-.364.56c-.119.222-.21.459-.392.932zm0 0 2.744-7.135c.197-.51.295-.766.463-.883a.67.67 0 0 1 .506-.107c.201.038.394.232.781.619l3.012 3.012c.387.387.58.58.619.781a.67.67 0 0 1-.107.506c-.117.168-.372.266-.883.463z"
  })));
};
export default SvgPencil2;